module.exports = __webpack_public_path__ + "img/story_2_egg@3x.9bb5ef98.png";